<template>
  <div class="card-responsible-user">
    <div class="card-responsible-user-trigger" @click="show = true">
      <img
        class="card-responsible-user-avatar"
        :src="avatarUrl"
        alt="Responsável"
      />
    </div>

    <div v-if="show" class="card-responsible-user-dropdown" @mouseleave="show = false">
      <div
        v-for="user in users"
        :key="user.id"
        class="card-responsible-user-option"
        @click="selectUser(user)"
      >
        <b-row>
          <b-col sm="3">
            <img
              class="card-responsible-user-option-avatar"
              :src="baseUrl + (!user.any ? 'noImage.png' : user.any)"
              alt=""
            />
          </b-col>
          <b-col sm="9">
            <span class="card-responsible-user-option-name">{{ user.content }}</span>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import CardService from "../../services/card.service";

import { mapActions } from "vuex";

const BASE_URL = "https://espaco.blob.core.windows.net/nixloc-photo-user/";

export default {
  name: "CardResponsibleUser",
  props: {
    cardId: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    urlGetUsers: {
      type: String,
      default: "/api/v1/adm/user/select-all-by-rule-name",
    },
  },
  data() {
    return {
      baseUrl: BASE_URL,
      users: [],
      currentUser: this.value || {},
      show: false,
    };
  },
  mounted() {
    this.loadUsers();
  },
  computed: {
    avatarUrl() {
      const photo = this.currentUser && this.currentUser.photo;
      return BASE_URL + (photo ? photo : "noImage.png");
    },
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    async loadUsers() {
      const params = {
        url: this.urlGetUsers,
        obj: { search: "", currentPage: 1, totalPerPage: 20, any: "CRM" },
      };
      const response = await this.getApi(params);
      this.users = response.content.data;
    },
    async selectUser(user) {
      this.currentUser = { id: user.id, photo: user.any };
      this.show = false;
      await CardService.updateResponsibleUser(this.cardId, user.id);
      this.$emit("input", this.currentUser);
    },
  },
  watch: {
    value: {
      handler(val) {
        this.currentUser = val || {};
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.card-responsible-user {
  position: relative;
  display: inline-block;
}

.card-responsible-user-trigger {
  cursor: pointer;
}

.card-responsible-user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 999px;
}

.card-responsible-user-avatar:hover {
  border-color: var(--color-brand);
}

.card-responsible-user-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 220px;
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 8px;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
}

.card-responsible-user-option {
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.card-responsible-user-option:hover {
  background: var(--bg-hover);
}

.card-responsible-user-option-avatar {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  object-fit: cover;
  margin: 4px;
}

.card-responsible-user-option-name {
  font-size: 13px;
  color: var(--text-primary);
  line-height: 34px;
}
</style>

